function Card(props: {
  variant?: string;
  extra?: string;
  children?: JSX.Element | any[];
  [x: string]: any;
}) {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`nina-surface relative flex flex-col rounded-[20px] border border-gray-100 bg-white bg-clip-border shadow-[0_8px_30px_rgba(112,144,176,0.12)] transition-shadow duration-200 dark:border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-[0_18px_50px_-24px_rgba(0,0,0,0.85)] dark:ring-1 dark:ring-inset dark:ring-white/5 ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
